export default function isInIFrame() {
  try {
    return window.self !== window.top
  } catch (e) {
    // Cross-origin error, assume it's in an iframe
    return true
  }
}
